import { httpClient } from "ultis/axios";

const getListIvr = (params) => {
  return httpClient.get("/cloud-pbx/ivrs", {
    params,
  });
};

const getCountListIvr = (params) => {
  return httpClient.get("/cloud-pbx/ivrs/count", {
    params,
  });
};

const getIvrDetail = (id) => {
  return httpClient.get(`/cloud-pbx/ivrs/${id}`);
};

const createIvr = (payload) => {
  return httpClient.post("/cloud-pbx/ivrs", payload);
};

const editIvr = (id, payload) => {
  return httpClient.put(`/cloud-pbx/ivrs/${id}`, payload);
};

const deleteIvr = (id) => {
  return httpClient.delete(`/cloud-pbx/ivrs/softDeleteById`, {
    params: { id },
  });
};

const uploadIvr = (payload) => {
  return httpClient.post("/cloud-pbx/ivrs/upload", payload);
};

export const IvrApi = {
  getListIvr,
  getCountListIvr,
  createIvr,
  editIvr,
  deleteIvr,
  uploadIvr,
  getIvrDetail,
};
